import { Component, OnInit, OnDestroy } from '@angular/core';
import { WebphoneService, WebphoneQuery } from '@etop/state/shop/webphone';
import { Observable } from 'rxjs';
import { PageBaseComponent } from '@etop/web';
import { ConfigService } from '@etop/core';

@Component({
  selector: 'etelecom-cs-call-outgoing',
  templateUrl: './call-outgoing.component.html',
  styleUrls: ['./call-outgoing.component.scss']
})
export class CallOutGoingComponent extends PageBaseComponent implements OnInit, OnDestroy {
  callingPhoneNumber$: Observable<string>;
  callingPhoneName$: Observable<string>;
  isVideoCall$: Observable<boolean>;
  crm_url: string;
  
  constructor(
    private webphoneService: WebphoneService,
    private webphoneQuery: WebphoneQuery,
    private config: ConfigService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.callingPhoneNumber$ = this.webphoneQuery.select(state => state.callingPhoneNumber);
    this.callingPhoneName$ = this.webphoneQuery.select(state => state.callingPhoneName);
    this.isVideoCall$ = this.webphoneQuery.select(state => state.isVideoCall);
    this.crm_url = this.config.get('crm_url');
  }

  async answerCall(): Promise<void> {
    try {
      await this.webphoneService.answer();
    } catch (error) {
      toastr.error(error.message || 'Không thể trả lời cuộc gọi');
    }
  }

  async hangupCall(): Promise<void> {
    try {
      await this.webphoneService.hangup();
    } catch (error) {
      toastr.error(error.message || 'Không thể từ chối cuộc gọi');
    }
  }

  openTicket() {
    const ticketUrl = this.crm_url + encodeURIComponent(
      this.webphoneQuery.getValue().callingPhoneNumber
    )
    window.open(ticketUrl, "_blank");
  }
}

